import {
  OreButton,
  OreCardContainer,
  OreCardWrapper,
  OreDivider,
  OreStack,
  OreText,
} from '@edenredespana/oreneta'
import { useTranslation } from 'react-i18next'

import { formTranslation } from '@/Shared/ui/sharedTranslation'
import { createApiStoreRepository } from '@/Store/infrastructure'
import { useStoreStickersController } from '@/Store/ui/hooks'
import { StoreStickersFormAddress, StoreStickersFormGeneral } from '@/Store/ui/molecules'
import { useUserData } from '@/User/ui/context'
import { useWebTagPermissions } from '@/User/context'
import { WebTagPermissionEnum } from '@/Shared/domain'
import { useEffect, useState } from 'react'

export const StoreStickersForm = (): JSX.Element => {
  const { t } = useTranslation()
  const [canGetMaterials, setCanGetMaterials] = useState(false);
  const { hasPermission, permissions } = useWebTagPermissions();
  const { merchant } = useUserData()
  const { form, save } = useStoreStickersController(
    createApiStoreRepository(),
    merchant.id,
  );

  useEffect(() => {
    setCanGetMaterials(hasPermission(WebTagPermissionEnum.ACTION_REQUEST_MATERIAL));
  }, [permissions]);

  return (
    <form>
      <OreCardContainer>
        <OreCardWrapper>
          <OreStack space="2xlarge" placeContent="stretch">
            <StoreStickersFormGeneral form={form} canGetMaterials={canGetMaterials} />
            <StoreStickersFormAddress form={form} canGetMaterials={canGetMaterials} isNursery={merchant.isNursery} />
            <OreText>{t(formTranslation.common.requiredFields)}</OreText>
          </OreStack>
        </OreCardWrapper>
      </OreCardContainer>

      <OreDivider space="larger-top" />
      <OreStack direction="row" placeContent="end" space="medium">
        <OreButton
          disabled={!canGetMaterials || !form.formState.isValid}
          type="submit"
          onClick={form.handleSubmit(save)}
          size="small"
          category="primary"
          data-testid="orderStickers"
        >
          {t(formTranslation.common.buttons.confirm)}
        </OreButton>
      </OreStack>
    </form>
  )
}
